export function showLinkMsg() {
  document.addEventListener('DOMContentLoaded', () => {
    const copyLinks = document.querySelectorAll('[data-id="link"]');

    copyLinks.forEach((copyLink) => {
      copyLink.addEventListener('click', () => {
        copyLink.classList.add('clicked');

        setTimeout(() => {
          copyLink.classList.remove('clicked');
        }, 2000);
      });
    });
  });
}
